import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../axios';
import { TeamMemberData } from '../types/teamMembersTypes';
import { RootState } from '../store';

export const fetchTeamMembers = createAsyncThunk<
  TeamMemberData[],
  void,
  { state: RootState; rejectValue: string }
>(
  'teamMembers/fetchTeamMembers',
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState();
      const managerId = state.auth.user?.id;
      if (!managerId) {
        return rejectWithValue('Manager ID not found');
      }
      const response = await axiosInstance.get(`/v1/admin/team-members/${managerId}`);
      if (response.data && response.data.success && Array.isArray(response.data.data)) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data.message || 'Failed to fetch team members');
      }
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Failed to fetch team members'
      );
    }
  }
); 
